<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>
  <ng-template suiDialogContent>
    <div class="sentiment-wrapper">
      <div
        class="sentiment-options"
        sui-radio-group
        [formControl]="sentimentControl"
        orientation="vertical"
      >
        @for (sentiment of sentimentValues; track sentiment.value) {
          <sui-radio [value]="sentiment.value">{{ sentiment.label }}</sui-radio>
        }
      </div>

      @if (sentimentManualChanges.length > 0) {
        <h4 class="sentiment-manual-change-title">
          {{ "post-sentiment.title.sentiment-scored-manually-by" | translate }}
        </h4>
        @for (
          change of sentimentManualChanges;
          track change.user + "-" + change.time_scored
        ) {
          @for (change of sentimentManualChanges; track change) {
            <div class="sentiment-manual-change">
              @for (field of sentimentManualChangesFields; track field.id) {
                <div class="change-info">
                  <span class="label">
                    {{ "post-sentiment.label." + field.label | translate }}
                  </span>
                  @if (!field.isImage) {
                    <span class="value">{{ field.value(change) }}</span>
                  }
                  @if (field.isImage) {
                    <img class="avatar" [src]="field.value(change)" />
                  }
                </div>
              }
            </div>
          }
        }
      }
    </div>
  </ng-template>
  <ng-template suiDialogFooter>
    <sui-button size="md" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      size="md"
      variant="primary"
      [disabled]="sentimentControl.invalid"
      (click)="save()"
    >
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
